module.exports = __webpack_public_path__ + "static/media/17UN-Women2.81f066d3.jpg";